import validate from "/Users/kevin/jenkins/git/media/player-client-gay/node_modules/.pnpm/nuxt@3.18.0_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@24.1.0_@vue+compiler-sfc@3_oq2rdosjjisl75fucu5a75f7qe/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/Users/kevin/jenkins/git/media/player-client-gay/node_modules/.pnpm/nuxt@3.18.0_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@24.1.0_@vue+compiler-sfc@3_oq2rdosjjisl75fucu5a75f7qe/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/Users/kevin/jenkins/git/media/player-client-gay/middleware/auth.ts"),
  "check-app-config": () => import("/Users/kevin/jenkins/git/media/player-client-gay/middleware/check-app-config.ts")
}